import {
  Checkbox as MuiCheckbox,
  CheckboxProps as MuiCheckboxProps,
} from '@mui/material';

import { CheckIconStyled, IconStyled } from './CheckboxStyled';

export interface CheckboxProps extends MuiCheckboxProps {
  id: string;
}

export const Checkbox = (props: CheckboxProps) => (
  <MuiCheckbox
    checkedIcon={<CheckIconStyled />}
    data-testid="checkbox-wrapper"
    icon={<IconStyled />}
    sx={{ width: '256px', marginLeft: '-218px' }}
    {...props}
  />
);
